import {TranslationMessages} from 'react-admin';
import germanMessages from './ra-language-german';

const customGermanMessages: TranslationMessages = {
    ...germanMessages,
    loading: 'Caricamento. Attendere prego ...',
    pos: {
        configuration: 'Impostazioni',
        language: 'Lingua',
        languageOptions: {
            english: 'en',
            german: 'de',
            french: 'fr',
            italian: 'it',
            spanish: 'es',
            russian: 'ru',
            swedish: 'se',
        },
        buttons: {
            save: 'Salvare',
            delete: 'Cancellare',
            close: 'Chiudere',
        },
    },
    errors: {
        invalid_record: 'Record non valido!'
    },
    resources: {
        'admin/dashboard': {
            name: 'Cruscotto',
            orders: 'Ordini del negozio',
            ordersLastDays: 'ultimi giorni',
            ordersLastMonths: 'ultimi mesi',
            users: 'Utenti',
            customers: 'Clienti',
            products: 'Prodotti',
            see_all: 'Vedi tutti',
            see_more: 'Per saperne di più',
            show_more: 'Espandi',
            show_less: 'Restringimento',
            offers: 'Offerte',
            results: {
                id: 'Id',
                sap_order_id: 'Id ordine Sap',
                cart_id: 'Carrello Id',
                total: 'Total (€)',
                total_formatted: 'Total (€)',
                created_at: 'Creato a',
                status: 'Stato',
                first_name: 'Nome',
                last_name: 'Cognome',
                email: 'Email',
                name: 'Nome',
                nrOrders: 'Numero ordini',
                formattedSumTotalOrders: 'Total (€)',
                formattedStatDate: 'Data',
                formattedCreatedAt: 'Creato a',
                formattedTotal: 'Total (€)',
                company: 'Firma',
            },
            'headers': {
                'total-revenue-this-year': `Vendite ${new Date().getFullYear()} (netto / totale)`,
                'total-revenue-this-month': `Mese corrente (netto / totale)`,
                'total-registered-customers-all-time': `Clienti registrati`,
                'total-registered-customers-now': `Nuovi clienti mensili / totale`,
                'average-revenue-by-nr-orders-last-12months': `⌀ Carrello (netto / totale)`,
                'average-revenue-by-month-last-12months' : `⌀ Vendite p.m (netto / totale)`,
                'average-revenue-by-subscriptions-last-12-months': `Abbonamenti / Volume (p.a.)`,
                'offers-orders-conversion-rate-last-12-months': `Offerte / Ordini da offerte / Conversione Offer2Order`,
                'revenue-this-year': `Andamento delle vendite al mese`,
                'total-revenue-by-main-category-this-month': `Vendite mese effettivo per area di prodotto`,
                'help.revenue-by-year': `Andamento delle vendite per anno solare`,
                'total-revenue-by-main-category-this-year': `Vendite ${new Date().getFullYear()} per area di prodotto`,
                'nr_active_users_by_country': `Numero di utenti attivi per paese`,
                'top-products-by-revenue-this-year': `Vendite top 5 prodotti (${new Date().getFullYear()})`,
            },
            'help': {
                //Umsatz 2022 (net / total)
                'total-revenue-this-year': `Vendite per tutti gli ordini che soddisfano i criteri:
                    - Stato = elaborato
                    - Fonte = Negozio
                    - Anno di creazione dell'ordine = anno corrente
                `,
                //Aktueller Monat (net / total)
                'total-revenue-this-month': `Vendite per tutti gli ordini che soddisfano i criteri:
                    - Stato = elaborato
                    - Fonte = Negozio
                    - Anno di creazione dell'ordine = anno corrente
                    - Mese di creazione dell'ordine = mese corrente`,

                //Angemeldete Kunden
                'total-registered-customers-all-time': `**NUMERO** di tutti gli utenti che soddisfano i criteri:
                    - Ruolo utente = Cliente
                    - Stato dell'utente = attivo
                    - Fonte di registrazione dell'utente = Negozio`,
                //Neukunden Monat / Total
                'total-registered-customers-now': `**NUMERO** di tutti gli utenti che soddisfano i criteri:
                    - Ruolo utente = Cliente
                    - Stato dell'utente = attivo
                    - Fonte di registrazione dell'utente = Negozio
                    - Mese/Anno di registrazione dell'utente = mese/anno corrente`,
                //⌀ Warenkorb (net / total)
                'average-revenue-by-nr-orders-last-12months': `**AVG = VENDITE / numero di ordini** di ordini che soddisfano i criteri:
                    - Ordine creato tra oggi e 12 mesi fa
                    - Fonte dell'ordine = Negozio
                    - Stato dell'ordine = elaborato`,
                //⌀ Umsatz p.m (net / total)
                'average-revenue-by-month-last-12months': `**AVG= TOTAL SALES / 12** of orders that meet the criteria:
                    - Ordine creato tra oggi e 12 mesi fa
                    - Fonte dell'ordine = Negozio
                    - Stato dell'ordine = elaborato`,

                //Abos / Volumen (p.a.)
                'average-revenue-by-subscriptions-last-12-months': `**Abbonamenti**
                        - Identificare tutti gli articoli del carrello della spesa che hanno una frequenza (= abbonamento) nel periodo ora - 12 mesi
                        - Calcolo del valore medio = totale abbonamenti / 12
                    **Sales (p.a.)**
                        - Identificare tutti gli articoli del carrello della spesa che hanno una frequenza (= abbonamento) nel periodo ora - 12 mesi
                        - Calcolo del valore medio = vendite (totale articoli) / numero di abbonamenti`,

                //Angebote / Bestellungen aus Angeboten / Conversion Angebot2Bestellung
                'offers-orders-conversion-rate-last-12-months': `**Offerte**: Numero di offerte che soddisfano i criteri:
                    - Offerte create tra oggi e 12 mesi e ora con un carrello specifico
                    ---
                    **Ordini da offerte**: Numero di ordini che soddisfano i criteri:
                    - Ordini creati tra oggi e 12 mesi fa
                    - Stato dell'ordine = elaborato
                    - Fonte dell'ordine = Negozio
                    - Carrello = tutti
                    ---
                    **Tasso di conversione**: Numero di ordini da offerte / numero di offerte* 100`,

                //Umsatzentwicklung pro Monat
                'revenue-this-year': `a) Raggruppare gli ordini per mese nell'anno in corso con i seguenti criteri d'ordine:
                    - Stato = elaborato
                    - Fonte = Negozio
                    - Anno di creazione dell'ordine = anno corrente
                    b) SOMMA (totale) per ogni gruppo di ordini
                    c) Calcolare l'aumento per ogni gruppo rispetto alla somma del mese precedente.`,

                //Umsatz Akt. Monat nach Produktbereich
                'total-revenue-by-main-category-this-month': `a) per ogni ordine - addebitiamo un importo totale per prodotto
                    Ad esempio:
                    - Prodotto A, importo totale: 1000 eur, categoria principale: ACS
                    - Prodotto B, importo totale: 2000 eur, categoria principale: ACS
                    b) Raggruppamento di tutti i prodotti ordinati per categoria principale di prodotto.
                    c) Per ogni gruppo, la somma (importo totale) di tutti i totali dei prodotti calcolati al punto a).
                    d) I prodotti ordinati devono far parte di ordini che soddisfano i criteri:
                        - Fonte dell'ordine = Negozio
                        - Stato dell'ordine = elaborato
                        - Anno di creazione/mese dell'ordine = anno/mese corrente`,

                //Umsatzentwicklung pro Kalenderjahr
                'revenue-by-year': `a) Raggruppamento degli ordini per anno, ordini con i seguenti criteri:
                    - Stato dell'ordine = evaso
                    - Fonte dell'ordine = Negozio
                    b) Vendite per ogni gruppo di ordini
                    c) Calcolare per ogni gruppo l'incremento rispetto al totale delle vendite dell'anno precedente.`,

                //`Umsatz 2022 nach Produktbereich
                'total-revenue-by-main-category-this-year': `a) per ogni ordine - addebitiamo un importo totale per prodotto
                    Ad esempio:
                    - Prodotto A, importo totale: 1000 eur, categoria principale: ACS
                    - Prodotto B, importo totale: 2000 eur, categoria principale: ACS
                    b) Raggruppamento di tutti i prodotti ordinati per categoria principale di prodotto.
                    c) Per ogni gruppo, la somma (importo totale) di tutti i totali dei prodotti calcolati al punto a).
                    d) I prodotti ordinati devono far parte di ordini che soddisfano i criteri:
                        - Fonte dell'ordine = Negozio
                        - Stato dell'ordine = elaborato
                        - Anno di creazione/mese dell'ordine = anno corrente`,

                //Umsatz Top 5 Produkte (2022)
                'top-products-by-revenue-this-year': `a) per ogni ordine addebitiamo un importo totale per prodotto
                    b) raggruppiamo tutti i prodotti ordinati per product_id
                    c) per ogni gruppo, si forma la somma di tutti i totali dei prodotti calcolati al punto a)
                    d) I prodotti ordinati devono far parte di ordini che soddisfano i criteri:
                        - Fonte dell'ordine = Negozio
                        - Stato dell'ordine = elaborato
                        - Anno di creazione dell'ordine = anno corrente`,
                //Nr active users by country
                'nr_active_users_by_country': `Numero di utenti attivi per paese`
            }
        },
        'admin/users': {
            name: 'Utenti',
            last_login: 'Ultimo accesso',
            from: 'Da',
            fields: {
                name: 'Nome',
                sap_status: 'Sap Stato',
                email_verified_at: 'Verificato presso',
                first_name: 'Nome',
                last_name: 'Cognome',
                email: 'Email',
                company: 'Azienda',
                send_reset_password_link: 'Invia il link per la reimpostazione della password',
                send_email_confirmation_link: 'SInviare il link di conferma via e-mail',
                email_verified: 'Email verificata'
            },
            roleOptions: {
                admin: 'Admin',
                sap: 'Sap',
                manager: 'Manager',
                customer: 'Customer',
                "location-manager": "Location Manager"
            },
            statusOptions: {
                active: 'Active',
                inactive: 'Inactive'
            },
            fieldGroups: {
                identity: 'Identity',
                password: 'Password',
                sap_data: 'Sap Data',
                invoice_address: 'Billing Address',
                client_info: 'Client Info'
            },
            fieldButtons: {
                reset_password: 'Reset Password',
                email_confirmation_link: 'Email Confirmation Link'
            },
            page: {
                delete: 'Delete User',
            },
            errors: {
                password_mismatch:
                    'The password confirmation is not the same as the password.',
            },
            titles: {
                edit_user: 'Edit user #%{info}',
            },
            messages: {
                are_you_sure_you_want_to_sent_the_reset_password_link: 'Are you sure you want to send the reset password link?',
                reset_password_link_sent: 'Resent password link sent with success',
                are_you_sure_you_want_to_sent_email_confirmation_link: 'Are you sure you want to send the email confirmation link?',
                email_confirmation_link_sent: 'Email confirmation link sent with success',
                are_you_sure_you_want_to_manually_confirm_the_user_email: 'Are you sure you want to manually confirm the user\'s email?',
                email_confirmed: 'Email confirmed with success'
            }
        },
        'admin/posts': {
            name: 'Posts',
            view: 'View Posts',
            create: 'Create Post',
            fields: { //these are used in the forms
                author: 'Author',
                role: 'Role',
                slug: 'Slug',
                status: 'Status',
                content: 'Content',
                title: 'Title',
                subtitle: 'Subtitle',
                id: 'Id',
                teaser_category_id: 'Category ID',
                bg_color: 'Background Color',
                bg_image_src: 'Background Image Src',
                text: 'Text',
                button_url: 'Button Url',
                button_text: 'Button Text',
                image_src: 'Image Src',
                image_path: 'Image Path',
                hierarchy: 'Hierarchy',
                template: 'Template',
                meta: {
                    price: 'Price',
                    button_text: 'Button text',
                    button_url: 'Button url',
                    title: 'Title',
                    image_src: 'Image src',
                    image_path: 'Upload image',
                    categories: 'Categories',
                    seo_title: 'SEO Title',
                    seo_description: 'SEO Description',
                    seo_keywords: 'SEO Keywords',
                    seo_robots: 'Robots'
                }
            },
            statusOptions: {
                publish: 'Publish',
                draft: 'Draft'
            },
            typeOptions: {
                page: 'Page',
                content: 'Content'
            },
            translationStatusOptions: {
                active: 'Active',
                inactive: 'Inactive'
            },
            section: {
                seo: 'Seo',
                post_info: 'Post Info',
                meta: 'Meta'
            },
            titles: {
                edit_post: 'Edit post #%{id}'
            },
            buttons: {
                show_on_shop: 'Show on Shop'
            }
        },
        'admin/products': {
            name: 'Products',
            titles: {
                show_product: 'Show product: %{name}',
                product_variations: 'Product Variations'
            },
            buttons: {
                show_on_shop: 'Show on Shop'
            },
            fields: {
                id: 'Id',
                name_or_id: 'Name or Id',
                top_seller: 'Top Seller',
                created_at: 'Created At',
                name: 'Name'
            }
        },
        'admin/variations': {
            fields: {
                name: 'Name',
                price: 'Price',
                matnr: 'OrderId'
            }
        },
        'admin/orders': {
            name: 'Ordini',
            fields: {
                product_id: 'Prodotto#',
                matnr: 'Matnr',
                product: 'Prodotto',
                manager: 'Manager',
                customer: 'Cliente',
                qty: 'Quantità',
                price: 'Prezzo',
                variation: 'Variazione',
                customer_name_or_email: 'Nome del cliente / e-mail',
                from: 'Da',
                to: 'A',
                total: 'Totale',
                created_at: 'Creato a',
                cad_url: 'CAD',
                print_url: 'Stampa',
                pending: 'In attesa',
                processed: 'Processato',
                payment_status: 'Stato del pagamento',
                sap_order_id: 'ID ordine su SAP',
                status: 'Stato',
                source: 'Origine',
                payment_method: 'Metodo di pagamento',
                unzer_short_id: 'Unzer Short ID',
                unzer_payment_id: 'Unzer Payment ID',
                shipping_date: 'Data di spedizione',
                shipping_date_notification_action: 'Azione sulla data di spedizione',
                approve_shipping_date: 'Inviare approvare la data di spedizione',
                reject_shipping_date: 'Inviare la data di spedizione del rifiuto',
            },
            badge: {
                sample: 'Campione',
            },
            titles: {
                edit_order: 'Ordine #%{id}'
            },
            buttons: {
                submit_to_sap: 'Invia a SAP'
            }
        },
        'admin/translations': {
            name: 'Translations',
            buttons: {
                save_translation: 'Save translation',
                publish_translation: 'Publish translation',
                reset: 'Reset',
                remove: 'Remove language',
                translate_field: 'Translate field',
                add_new_language: 'Add new language',
            },
            messages: {
                translation_saved: 'Translation saved with success!',
                translation_not_saved: 'Error! Translation not saved!',
                translation_reset: 'Translation reset with success!',
                translation_not_reset: 'Error! Translation not reset!',
                translation_published: 'Translation published with success!',
                translation_not_published: 'Error! Translation not published!',
                you_have_unsaved_changes: 'Warning! Your have unsaved translations, are you sure your want to continue?',
                language_added: 'Language added successfully.',
                language_not_added: 'Error! Language was not added.',
                cannot_remove_de_or_only_language: 'DE langauge cannot be removed.',
                removed_language: 'Error! Language removed successfully.',
                failed_removed_language: 'Language was not removed',
                please_select_language_from_and_to: 'Please select new language and template language.',
            },
            fields: {
                all_locales: "Choose new language!",
                template_language: "Choose template language!"
            }
        },
        'admin/mail-templates': {
            name: 'Mail Templates',
            fields: {
                subject: 'Subject',
                cc: 'CC',
                to: 'TO',
                bcc: 'BCC'
            },
            titles: {
                edit_mail_template: 'Edit mail template #%{id}'
            },
            statusOptions: {
                active: 'Active',
                draft: 'Draft'
            },
        },
        'admin/backups': {
            name: 'Backups',
            fields: {
                path: 'Path',
            },
            buttons: {
                restore: 'Restore'
            },
            messages: {
                'restore_with_success': 'Restore has been scheduled with success',
                'restore_failed': 'Restore failed'
            }
        },
        'admin/lod': {
            name: 'LOD',
        },
        'admin/lod-colors': {
            name: 'Colors',
            titles: {
                create: 'Add new Color',
                edit: 'Edit Color: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-foils': {
            name: 'Foils',
            titles: {
                create: 'Add new Foil',
                edit: 'Edit Foil: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-thickness': {
            name: 'Thickness',
            titles: {
                create: 'Add new Thickness',
                edit: 'Edit Thickness: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-materials': {
            name: 'Materials',
            titles: {
                create: 'Add new Material',
                edit: 'Edit Material: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-holes': {
            name: 'Holes',
            titles: {
                create: 'Add new Hole',
                edit: 'Edit Hole: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-shapes': {
            name: 'Shapes',
            titles: {
                create: 'Add new Shape',
                edit: 'Edit Shape: %{name}'
            },
            status: {
                active: 'active',
                inactive: 'inactive',
            }
        },
        'admin/lod-price-matrix': {
            name: 'Price Matrix',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {
                material: 'Material',
                thickness: 'Thickness',
                signs: 'signs'
            }
        },
        'admin/lod-raw-material-prices': {
            name: 'Raw Material Prices',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {
                material: 'Material',
                thickness: 'Thickness',
                color: 'Color',
                foil: 'Foil',
                price: 'Price'
            }
        },
        'admin/lod-hole-image-shape': {
            name: 'Hole/Image/Shape',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            orientation: {
                landscape: 'Landscape',
                portrait: 'Portrait'
            },
            fields: {
                image: 'Image',
                shape: 'Shape',
                hole: 'Hole',
                mass_1: 'L',
                mass_2: 'B',
                mass_3: 'D',
                mass_4: 'd',
                mass_5: 'R',
                mass_6: 'x',
                mass_7: 'y',
                mass_8: 'X1',
                mass_9: 'X2',
                mass_10: 'Y1',
                mass_11: 'Y2'
            }
        },
        'admin/lod-material-configs': {
            name: 'Material Configs',
            titles: {
                edit: 'Edit material config',
                create: 'Create material config'
            },
            sections: {
                gewicht: 'Gewicht',
                mattenbreite: 'Mattenbreite',
                menge: 'Menge',
                wkz: 'WKZ',
                rohmaterial: 'Rohmaterial',
                rabatt: 'Rabatt'
            },
            status: {
                'active': 'Active',
                'inactive': 'Inactive'
            },
            fields: {
                material: 'Material',
                thickness: 'Thickness',
                gewicht: {
                    matte_248x248_in_gramm: 'Matte 248x248 in Gramm',
                    pro_mm2_in_g: 'Pro mm2 in g'
                },
                wkz: {
                    '1_klein': 'WKZ 1 (klein)',
                    '2_gross': 'WKZ 2 (gross)',
                    'umfang': 'WKZ Umfang'
                },
                foil_id: "Foil",
                color_id: "Color",
                extra_charge: "Extra charge"
            }
        },
        'admin/lod-images': {
            name: 'Images',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {
                image_path: 'Image file'
            }
        },
        'admin/lod-price-list': {
            name: 'Price list',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {}
        },
        'admin/lod-price-list-factors': {
            name: 'Price list Factors',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {
                price_list: 'Price list'
            }
        },
        'admin/lod-quellwerk': {
            name: 'Quellwerk',
            titles: {
                create: 'Add new Record',
                edit: 'Edit Record: %{name}'
            },
            fields: {}
        },
        'admin/offers': {
            name: 'Offerte',
            fields: {
                total: 'Totale',
                created_at: 'Creato a',
                company: 'Azienda',
                processed: 'Processato',
                active: 'Attivo',
                expired: 'Scaduto',
                cart_status: 'Stato del carrello',
                client_offer_id: 'ID offerta del cliente',
                cart_id: 'ID carrello'
            },
            buttons: {
                export: 'PDF'
            }
        },
        'admin/lod-wintyps': {
            name: 'Wintyps',
            titles: {
                create: 'Add new Wintyp',
                edit: 'Edit Wintyp: %{name}'
            },
            fields: {
                blocked_at: 'Blocked',
                used_at: 'Used',
                product: 'Product',
                order_id: 'Order #'
            }
        },
        'admin/shipping-dates': {
            name: 'Shipping Dates',
            titles: {
                shipping_countries: 'Shipping Countries',
                shipping_date: 'Shipping Date',
                create: 'Add new Shipping Date',
                edit: 'Edit Record: %{name}',
            },
            sections: {
                recurrence: 'Recurrence'
            },
            fields: {
                shipping_country_ids: 'Shipping Countries (iso2)'
            }
        },
        'admin/shipping-countries': {
            name: 'Shipping Countries',
            titles: {
                create: 'Add new Shipping Country',
                edit: 'Edit Shipping Country: %{name}'
            },
            fields: {
                code: 'Country Code (iso 2)'
            }
        },
        'admin/shipping': {
            name: 'Shipping'
        },
        'admin/cob': {
            name: 'COB'
        },
        'admin/cob-cobots': {
            name: 'Cobots',
            fields: {
                manufacturer: 'Manufacturer',
                type: 'Type',
                model: 'Model',
                axis6_tape: 'Axis 6 Tape',
                system_holder_1: 'System Holder #1',
                system_holder_2: 'System Holder #2',
                hose_length: 'Hose Length',
                tension_clamp: 'Tension Clamp',

                //ua
                ua_shs_center: 'Center',
                ua_shs_outside: 'Outside',
                ua_shs_inside: 'Inside',
                ua_tape_center: 'Center',
                ua_tape_outside: 'Outside',
                ua_tape_inside: 'Inside',
                ua_feeding_system: 'Feeding System',

                //lq
                la_shs_center: 'Center',
                la_shs_outside: 'Outside',
                la_shs_inside: 'Inside',
                la_tape_center: 'Center',
                la_tape_outside: 'Outside',
                la_tape_inside: 'Inside',
                la_feeding_system: 'Feeding System'

            },
            titles: {
                create: 'Add New Cobot',
                edit: 'Edit Cobot %{name}'
            },
            fieldGroups: {
                manufacturer_details: 'Manufacturer Details',
                technical_master_data: 'Technical Master Data',
                technical_details_upper_support_arm: 'Technical Details - Upper Arm',
                technical_details_bottom_support_arm: 'Technical Details - Lower Arm',
                shs: 'SHS',
                tape: 'Tape'
            }
        },
        'admin/cob-manufacturers': {
            name: 'Manufacturers',
            titles: {
                create: 'Add New Manufacturer',
                edit: 'Edit Manufacturer: %{name}'
            }
        },
        'admin/cob-types': {
            name: 'Types',
            titles: {
                create: 'Add New Type',
                edit: 'Edit Type: %{name}'
            },
            fields: {
                manufacturer: 'Manufacturer'
            }
        },
        'admin/cob-models': {
            name: 'Models',
            titles: {
                create: 'Add New Model',
                edit: 'Edit Model: %{name}'
            },
            fields: {
                manufacturer: 'Manufacturer',
                type: 'Type'
            }
        },
        'admin/cob-products': {
            name: 'Products',
            titles: {
                create: 'Add New Product',
                edit: 'Edit Product: %{name}'
            },
            fieldGroups: {
                product_details: 'Details',
                product: 'Product'
            },
            fields: {
                name: 'Name',
                nominal_size: 'Nominal size',
                profile: 'Profile',
                configuratorStatus: 'Configurator status'
            },
            group: {
                hose: 'Hose',
                hose_hf: 'Hose Highly Flexible',
                tension_clamp: 'Tension Clamp',
                belt: 'Belt',
                system_holder: 'System Holder',
                end_grommet: 'End Grommet',
                hose_ring_zl: 'Hose Ring Zl',
                hose_ring_fixed: 'Hose Ring Fixed',
                shs: 'SHS',
                fhs_c: 'System Holder FHS-C',
                fhs_uhe: 'System Holder FHS-UHE',
                fhs_sh: 'System Holder FHS-SH',
                options: 'Option',
                velcro: 'Velcro',
                velcro_silicone_free: 'Velcro silicone free',
                stainless_steel_band: 'Stainless Steel Band',
                return_system: 'Return System',
                universal_holder: 'Universal Holder',
                hose_ring_sliding: 'Hose Ring Sliding'
            },
            design: {
                slotted: 'Slotted',
                closed: 'Closed'
            },
            status: {
                active: 'Active',
                inactive: 'Inactive'
            }
        }
    }
};

export default customGermanMessages;
